import React, { Component, PropTypes } from "react";
import {
  FormControlLabel,
  FormControl,
  Checkbox,
  FormHelperText,
} from "material-ui";
import styles from "./checkBoxValidation.scss";

class CheckboxWithLabelAndError extends Component {
  render() {
    const {
      input,
      label,
      classes,
      meta: { touched, error },
      children,
      ...custom
    } = this.props;
    return (
      <FormControl error={Boolean(touched && error)} fullWidth>
        <FormControlLabel
          label={label}
          control={
            <Checkbox
              name="test"
              {...input}
              onChange={(event, value) => input.onChange(value)}
              value={!!input.value ? String(!!input.value) : null}
              checked={!!input.value}
              {...custom}
            >
              {children}
            </Checkbox>
          }
        />
        {touched && error && (
          <FormHelperText className={styles.checkboxError}>
            {"Vous devez accepter les CGU pour créer votre compte"}
          </FormHelperText>
        )}
      </FormControl>
    );
  }
}

export default CheckboxWithLabelAndError;



// WEBPACK FOOTER //
// ./src/pages/utils/checkbox/checkBoxValidation.jsx